import { MagnifyingGlassIcon, SpinnerGapIcon } from '@phosphor-icons/react';
import { Input } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { selectActiveFilters, setFilter } from '../../../../store/products/slice';
import { useState } from 'react';
import { useSearchProductsInfiniteQuery } from '../../../../store/products/productsApi';

const Search = () => {
  const dispatch = useAppDispatch();
  const [value, setValue] = useState('');

  const activeFilters = useAppSelector(selectActiveFilters);

  const { isFetching } = useSearchProductsInfiniteQuery({
    filters: activeFilters,
  });

  const handleSearch = () => {
    dispatch(
      setFilter({
        field: 'query',
        filterType: 'QUERY',
        values: value ? [value] : [],
      }),
    );
  };

  return (
    <Input
      placeholder="Search..."
      suffix={
        isFetching ? (
          <SpinnerGapIcon className="anticon-spin" style={{ color: '#bfbfbf' }} />
        ) : (
          <MagnifyingGlassIcon style={{ color: '#bfbfbf' }} />
        )
      }
      allowClear
      value={value}
      onChange={e => setValue(e.target.value)}
      onPressEnter={handleSearch}
      style={{
        maxWidth: 320,
        borderRadius: 20,
      }}
    />
  );
};

export default Search;
